import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ManikEntityFE, CookieManager } from 'src/manik-library/ManikEntityFE';
import { ManikEntityService } from 'src/manik-library/ManikEntityService';
import { DOCUMENT } from '@angular/common';
import { ManikHeaders } from 'src/manik-library/manik-header.service';

@Component({
  selector: 'app-visitor-handler',
  templateUrl: './visitors-login-management.component.html'
})
export class VisitorHandlerComponent extends ManikEntityFE implements OnInit {
  submitted = false;
  VisitorPhoneForm: FormGroup;
  VisitorDetailsForm: FormGroup;
  OTPForm: FormGroup; 
  SessionData: any;
  IsInitialised: boolean = false;
  maxlength: any;
  CountryList: any;
  ShowForm: boolean = false;
  ShowLoader: boolean = false;
  ShowVerifyOTP: boolean = false;
  EmailError = '*required';
  AskEmail: boolean = false;
  VisitorData: any = {};
  OTPHandle: string = '';
  @Input() CountryID = 100023;
  @Input() PortalID = 100002;
  @Input() PortalName: string;
  @Output() visitorLoggedIn = new EventEmitter();

  populateControls(): void {
    throw new Error("Method not implemented.");
  }
  refreshDataGrid(param: any): void {
    throw new Error("Method not implemented.");
  }

  constructor(private formBuilder: FormBuilder, public _manikEntityService: ManikEntityService, @Inject(DOCUMENT) public document: any, private _header: ManikHeaders) {
    super();
    this.VisitorPhoneForm = this.formBuilder.group({
      Country: [''],
      CountryCode: [''],
      CountryAC: [''],
      CountryID: [''],
      MobileNumber: ['', Validators.required]
    });
    this.VisitorDetailsForm = this.formBuilder.group({
      VisitorName: ['', Validators.required],
      EmailID: ['', Validators.required],
      Password: ['', Validators.required],
      OKToContactBack: ['', Validators.required]
    });
    this.OTPForm = this.formBuilder.group({
      OTP: ['', Validators.required],
      CouponHandle: ['']
    });
  }

  ngOnInit() {
    this.IsInitialised = false;
    this.SessionData = JSON.parse(sessionStorage.getItem("WebSiteMetaData"));
    this._header.updateFilterParams('');
    this._manikEntityService.manikAutoComplete2(this.EndPoint+"entitymgr", null,
      this._header.prepareAddlQueryHeaders2("SEMI.QUICK", "GET.COUNTRY", "MANIK.GLOBAL"))
      .subscribe(data => {
        let resp: any = data;
        this.CountryList = resp.ManikJSon[0].JSon0;
        let country = resp.ManikJSon[0].JSon0.find(item => item.DataValue == this.CountryID);
        this.VisitorPhoneForm.controls['CountryAC'].setValue(country);
        this.VisitorPhoneForm.controls['CountryCode'].setValue(country.CountryCode);
        this.VisitorPhoneForm.controls['Country'].setValue(country.DataText);
        this.VisitorPhoneForm.controls['CountryID'].setValue(country.DataValue);
        this.maxlength = country.MobileNumberLength;
        this.VisitorPhoneForm.controls['MobileNumber'].setValidators([Validators.required, Validators.maxLength(this.maxlength), Validators.minLength(this.maxlength)]);
        this.VisitorPhoneForm.controls['MobileNumber'].updateValueAndValidity();
        this.IsInitialised = true;
      });
  }


  GetCountryList() {
    this._header.updateFilterParams(this.VisitorPhoneForm.value.CountryAC);
    return this._manikEntityService.manikAutoComplete2(this.EndPoint+"entitymgr", null,
      this._header.prepareAddlQueryHeaders2("SEMI.QUICK", "GET.COUNTRY", "MANIK.GLOBAL")).subscribe(
        data => {
          let resp: any = data;
          this.CountryList = resp.ManikJSon[0].JSon0;
        });

  }

  OnSelectCountry(event: any) {
    let x = this.CountryList.find(item => { return item.DataValue.toString == event.target.value });
    this.VisitorPhoneForm.controls['CountryCode'].setValue(x.CountryCode);
    this.VisitorPhoneForm.controls['Country'].setValue(x.DataText);
    this.VisitorPhoneForm.controls['CountryID'].setValue(x.DataValue);
    this.maxlength = x.MobileNumberLength;
  }


  CheckIfContactExists() {
    this.ShowForm = false;
    if (this.VisitorPhoneForm.controls['MobileNumber'].errors) {
      return;
    }
    this.ShowLoader = true;
    this._header.updateFilterParams(this.PortalID, this.VisitorPhoneForm.controls['CountryCode'].value, this.VisitorPhoneForm.controls['MobileNumber'].value);//this.SessionData.PortalID
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this._header.prepareAddlQueryHeaders2("FETCH.BY.MOBILE", "VISITOR", "MANIK.GLOBAL")).subscribe(
        data2 => {
          let resp = data2.ManikJSon[0].JSon0[0].VisitorName;
          if (resp != null) {
            this.AskEmail = false;
            this.ShowForm = true;
            this.ShowLoader = false;
            this.VisitorDetailsForm.controls["VisitorName"].setValue(resp);
            this.VisitorDetailsForm.controls["VisitorName"].disable();
            this.VisitorDetailsForm.controls["EmailID"].setValue(data2.ManikJSon[0].JSon0[0].EmailID);
            this.VisitorDetailsForm.controls["EmailID"].disable();
            this.VisitorData = data2.ManikJSon[0].JSon0[0];
            this.OTPHandle = data2.ManikJSon[0].JSon1[0].OTPHandle;
            this.ShowVerifyOTP = true;
          }
          if (resp == null) {
            this.AskEmail = true;
            this.ShowForm = true;
            this.ShowLoader = false;
            this.VisitorDetailsForm.controls["VisitorName"].enable();
            this.VisitorDetailsForm.controls["EmailID"].enable();
            this.VisitorDetailsForm.controls["EmailID"].setValidators([Validators.required, Validators.email,
            Validators.pattern("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$")])
          }
        });
  }


  convertDateString(date: any) {
    let dates = this.getManikDateString(date);
    let myDate = new Date(dates);
    let d = myDate.getDate();
    let m = myDate.getMonth();
    m += 1;
    var y = myDate.getFullYear();
    date = (y + "-" + m + "-" + d);
    return date;
  }


  SubmitForm() {
    this.submitted = true;
    if (this.VisitorDetailsForm.invalid) {
      return;
    }
    if (this.AskEmail) {
      let body: any = {};
      body['PortalID'] = this.PortalID;
      body['VisitorName'] = this.VisitorDetailsForm.controls.VisitorName.value;
      body['EmailID'] = this.VisitorDetailsForm.controls.EmailID.value;
      body['CountryCode'] = this.VisitorPhoneForm.controls.CountryCode.value;
      body['MobileNumber'] = this.VisitorPhoneForm.controls.MobileNumber.value;
      body['OKToContactBack'] = this.VisitorDetailsForm.controls.OKToContactBack.value == true ? 'Y' : 'N';
      this._manikEntityService.manikEntityConnect2("portal/encript?data=" + this.VisitorDetailsForm.controls.Password.value, null, null)
        .subscribe(data => {
          body['EncryptedPassword'] = data.EncryptedData;
          let FrmSubmittedData = JSON.stringify({ 'items': [body] });
          this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", FrmSubmittedData, this._header.prepareManageHeaders2('A', "VISITOR", "MANIK.GLOBAL"))
            .subscribe(data => {
              if (data.ManikJSon[0].JSon0[0].NewEntity == 'ALREADY_EXISTS') {
                this.VisitorDetailsForm.controls['EmailID'].reset();
                this.EmailError = 'email ID already in use'
              }
              else {
                this.VisitorData = data.ManikJSon[0].JSon0[0];
                this.OTPHandle = data.ManikJSon[0].JSon1[0].OTPHandle;
                this.ShowVerifyOTP = true;
                //
                this.ShowForm = false;
                this.IsInitialised = false;
                //
              }
              this.submitted = false;

            });
        });
    }
  }

  OTPVerified() {
    CookieManager.setCookie('VisitorData', JSON.stringify(this.VisitorData), 1, '/');
    this.visitorLoggedIn.emit('Y');
  }

}




//@Component({
//    selector: 'app-visitors-login-management',
//    templateUrl: './visitors-login-management.component.html'
//})
//export class VisitorsLoginManagementComponent implements OnInit {
//    VisitorForm: FormGroup;
//    public countriesList: any = [];
//    RegisterVisitor: boolean = false;
//    VerifyOTP: boolean = false;
//    VisitorDetails: any = {
//        "VisitorName": "", "EmailID": "", "VisitorHandle": ""
//    };
//    ManikMyData: any;
//    constructor(
//        private formBuilder: FormBuilder,
//        private _manikEntityService: ManikEntityService,
//        @Inject(DOCUMENT) private document: any,
//        private router: Router,
//        private _header: ManikHeaders) {
//        this.VisitorForm = this.formBuilder.group({
//            CountryCode: '',
//            MobileNumber: ['', Validators.required],
//            VisitorName: ['', Validators.required],
//            EmailID: ['', Validators.compose([
//                Validators.required,
//                Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')
//            ])],
//            Password: ['', Validators.required],
//        });
//    }

//    populateControls(): void {
//    }
//    refreshDataGrid(param: any): void {
//    }

//    ngOnInit() {
//        sessionStorage.removeItem("vistorData");
//    }

//    getCountriesList(): void {
//        let term: any = this.VisitorForm.get('CountryCode');
//        this._header.updateFilterParams("MYCITY123", "N", term.value);
//        this._manikEntityService.manikAutoComplete2(this.EndPoint+"entitymgr", null,
//            this._header.prepareAddlQueryHeaders2("GET.COUNTRY.CODE", "BUSINESS.JOINFORFREE", "MANIK.GLOBAL"))
//            .subscribe(data => {
//                let resp: any = data;
//                this.countriesList = resp.ManikJSon[0].JSon0;
//            })
//    }

//    getCountryCode(country: any): string {
//        let data: any = { "CountryCode": country.CountryCode };
//        this.ManikMyData = data;
//        return country ? country.Country : country;
//    }

//    getVisitorDetails(): void {
//        let Mobile: any = this.VisitorForm.get('MobileNumber');
//        let CountryCode: any = this.VisitorForm.get('CountryCode');
//        this._header.updateFilterParams(CountryCode.value.CountryCode, Mobile.value);
//        this._manikEntityService.manikAutoComplete2(this.EndPoint+"entitymgr", null,
//            this._header.prepareAddlQueryHeaders2("FETCH.BY.MOBILE", "VISITOR", "MANIK.GLOBAL"))
//            .subscribe(data => {
//                let resp: any = data;
//                this.RegisterVisitor = false;
//                if (!resp.ManikJSon[0].JSon0[0].MobileNumber) {
//                    this.RegisterVisitor = true;
//                }
//                else {
//                    this.VisitorDetails = resp.ManikJSon[0].JSon0[0];
//                    this.VerifyOTP = true;
//                }
//            })
//    }

//    VerifyVisitorOTP(VerifyOTPForm: NgForm): void {
//        if (VerifyOTPForm.invalid) {
//            return;
//        }
//        let data: any = VerifyOTPForm.value;
//        data.VisitorHandle = this.document.getElementById("VisitorHandle").value;
//        this._header.updateFilterParams(data.VisitorHandle, data.OTP);
//        this._manikEntityService.manikAutoComplete2(this.EndPoint+"entitymgr", null,
//            this._header.prepareAddlQueryHeaders2("VERIFY.PASSCODE", "VISITOR", "MANIK.GLOBAL"))
//            .subscribe(data => {
//                let resp: any = data;
//            });
//    }

//    SubmitToDataBase(): void {
//        if (this.VisitorForm.invalid) {
//            return;
//        }

//        let body: any = this.VisitorForm.value;
//        body["CountryCode"] = body.CountryCode.CountryCode;
//        let sOperation: string = "A";
//        let FormSubmittedData = JSON.stringify({ 'items': [body] });
//        this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", FormSubmittedData,
//            this._header.prepareManageHeaders2(sOperation, "VISITOR", "MANIK.GLOBAL"))
//            .subscribe(data => {
//                let response: any = data;
//                sessionStorage.setItem("vistorData", JSON.stringify(response.ManikJSon[0].JSon0));
//                let localurl: Array<string> = [];
//                let currentURL: string = "";
//                currentURL = sessionStorage.getItem("url");
//                localurl = currentURL.split('/');
//                if (localurl.length > 5) {
//                    this.router.navigateByUrl('/' + localurl[3] + '/' + localurl[4] + '/' + localurl[5]);
//                }
//                else {
//                    this.router.navigateByUrl('/' + localurl[3] + '/' + localurl[4]);
//                }
//            });
//    }
//}
